import * as Dialog from '@radix-ui/react-dialog';
import type { Card, Position } from '@whispers/sdk';

import { DeckCardImage } from './DeckCardImage';

type CardDetailDialogProps = {
  card: Card | undefined;
  deckSlug: string | undefined;
  position: Position | undefined;
  open: boolean;
  onClose: () => void;
};

export const CardDetailDialog = ({
  card,
  deckSlug,
  position,
  open,
  onClose,
}: CardDetailDialogProps) => {
  if (!card) {
    return null;
  }

  return (
    <Dialog.Root open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-40 bg-shadow/50 animate-slideUpAndFade" />
        <Dialog.Content className="fixed left-1/2 top-1/2 z-50 max-h-[85vh] w-[90vw] max-w-md -translate-x-1/2 -translate-y-1/2 overflow-y-auto rounded-lg bg-surface p-6 shadow-xl animate-slideUpAndFade">
          <Dialog.Title className="text-xl font-medium text-text">{card.name}</Dialog.Title>

          {position && (
            <Dialog.Description className="mt-1 text-sm font-medium uppercase tracking-wide text-disabled-text">
              {position.name}
            </Dialog.Description>
          )}

          <div className="mt-4">
            <DeckCardImage
              className="mx-auto max-w-[200px]"
              slug={card.slug}
              deckSlug={deckSlug}
              name={card.name}
            />
          </div>

          {card.description && <p className="mt-4 text-text-secondary">{card.description}</p>}

          {position?.description && (
            <div className="mt-4 rounded-lg bg-surface-sunken p-3">
              <p className="text-sm font-medium text-text-secondary">Position meaning</p>
              <p className="mt-1 text-sm text-text-secondary">{position.description}</p>
            </div>
          )}

          <Dialog.Close asChild>
            <button
              className="mt-6 w-full rounded-lg bg-button-solid-bg px-4 py-2 text-sm font-medium text-text-inverse transition-colors hover:bg-button-solid-bg-hover"
              aria-label="Close"
            >
              Close
            </button>
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
